import { render, staticRenderFns } from "./HardCtrCom.vue?vue&type=template&id=be9b3d48&"
import script from "./HardCtrCom.vue?vue&type=script&lang=ts&"
export * from "./HardCtrCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports